import React from "react";
import { createRoot } from "react-dom/client";
import Pages from "./pages";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import reportWebVitals from "./reportWebVitals";
import createStore from "./store";
import ScriptInjecter from "./helpers/ScriptInjecter";
import { GoogleAnalyticsProvider } from "./components/TrackingProviders"; // Import the tracking providers
import './polyfills/promiseWithResolvers'; // 👈 ¡Esto va primero!
import * as Sentry from '@sentry/react';

// Initialize Sentry for file upload error tracking
Sentry.init({
  dsn: "https://637eb99ef12e8d699098044d316c2433@o745636.ingest.us.sentry.io/4510189814153216",
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.REACT_APP_ENVIRONMENT === 'production' ? 0.1 : 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions
  replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
  // Send default PII data (IP address)
  sendDefaultPii: true,
  // Only capture errors, not breadcrumbs by default (we'll add them manually)
  beforeBreadcrumb(breadcrumb) {
    // Only keep breadcrumbs related to file uploads and checkout
    if (breadcrumb.category === 'file_upload' || breadcrumb.category === 'storage' || breadcrumb.category === 'checkout') {
      return breadcrumb;
    }
    return null;
  },
});

const store = createStore();

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <GoogleAnalyticsProvider trackingId={process.env.REACT_APP_GA4_ID || ""}>
          <ScriptInjecter />
          <Pages />
        </GoogleAnalyticsProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
